import { UseQueryResult, useQuery } from 'react-query'
import request from '../../request'

type ResultType = {
  last_updated: string
}

export const useGetLastUpdatedDealerVaultPartners = (): UseQueryResult<
  { data: ResultType },
  Error
> => {
  return useQuery<{ data: ResultType }, Error>(
    ['admin', 'partners', 'dealervault', 'last_updated'],
    ({ signal }) =>
      request({
        url: `/admin/partners/dealervault/last_updated`,
        method: 'GET',
        signal,
      }),
  )
}
